// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"1526":"928cbd28","3915":"1ed7f894","4616":"4e625e61","5289":"5e026f5d","6319":"a88472b9","9421":"928cbd28"}[chunkId] + ".chunk.css";
};